import React from 'react';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'mismatches', label: 'Mismatches' },
  { id: 'compare', label: 'Compare' },
  { id: 'json', label: 'Raw JSON' },
];

export default function ProcessingReportTabs({ activeTab, onChange, mismatchCount = 0 }) {
  return (
    <div className="pr-tabs-bar">
      <div className="inc-source-tabs pr-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`inc-source-tab ${activeTab === tab.id ? 'inc-source-tab--active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
            {tab.id === 'mismatches' && mismatchCount > 0 && (
              <span className="pr-tabs__badge">{mismatchCount}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export { TABS };
